// package.json
var version = "0.39.3";

// src/version.ts
var compatibilityVersion = 10;
export {
  compatibilityVersion,
  version as npmVersion
};
